/**
 * A single item inside a <scroll-stack>. Purely structural: it is the layout
 * and pinning box, and it carries the read-only `--scroll-stack-progress` /
 * `--scroll-stack-edge` custom properties the parent writes. The visual effect
 * lands on its first element child, so the wrapper can pin while the content
 * scales and fades without fighting each other.
 * @class ScrollStackItem
 * @extends HTMLElement
 */
export class ScrollStackItem extends HTMLElement {}

if (!customElements.get('scroll-stack-item')) {
	customElements.define('scroll-stack-item', ScrollStackItem);
}
